// 🐼 Ζώνες Παράδοσης MrPanda — γρήγορος (προσεγγιστικός) υπολογισμός βάσει
// συντεταγμένων, για ενημερωτικά banners στο storefront.
// Ο ακριβής υπολογισμός κόστους γίνεται στο checkout (Google Routes).

export const MRPANDA_STORE_LAT = 40.6738; // Π. Λεβαντή 15Α, Σταυρούπολη
export const MRPANDA_STORE_LNG = 22.9174;

// Ίδια κλιμάκωση με το checkout (src/lib/shipping.functions.ts)
export const MRPANDA_TIERS = [
  { maxKm: 5, freeOver: 25, cost: 3 },
  { maxKm: 10, freeOver: 40, cost: 4 },
  { maxKm: 15, freeOver: 50, cost: 5 },
  { maxKm: 20, freeOver: 60, cost: 6 },
  { maxKm: 25, freeOver: 70, cost: 7 },
  { maxKm: 30, freeOver: 80, cost: 8 },
  { maxKm: 35, freeOver: 90, cost: 9 },
  { maxKm: 40, freeOver: 120, cost: 12 },
];

export const MRPANDA_MAX_KM = 40;
// Οι ευθείες αποστάσεις υποεκτιμούν τη διαδρομή — μικρός συντελεστής δρόμου.
const ROAD_FACTOR = 1.25;

export function haversineKm(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number,
): number {
  const R = 6371;
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export type MrPandaZone = {
  serviceable: boolean;
  distanceKm: number;
  freeOver: number | null;
  cost: number | null;
};

export function zoneForCoords(lat: number, lng: number): MrPandaZone {
  const raw = haversineKm(MRPANDA_STORE_LAT, MRPANDA_STORE_LNG, lat, lng);
  const distanceKm = Math.round(raw * ROAD_FACTOR * 10) / 10;
  if (distanceKm > MRPANDA_MAX_KM) {
    return { serviceable: false, distanceKm, freeOver: null, cost: null };
  }
  const tier =
    MRPANDA_TIERS.find((t) => distanceKm <= t.maxKm) ??
    MRPANDA_TIERS[MRPANDA_TIERS.length - 1];
  return { serviceable: true, distanceKm, freeOver: tier.freeOver, cost: tier.cost };
}
